export const SHOULD_CHECK_ITEM_IN_OFFER = true;
